import React from 'react';
import Modal from 'react-bootstrap/Modal';
import ProductTooltip from './ProductTooltip';
import ProductInput from './ProductInput';
import ProductLabel from './ProductLabel';
import ProductCheckbox from './ProductCheckbox';
import ChangesTable from './ChangesTable';
import '../styles.css';

const ProductModal = React.memo(function ProductModal({
  selectedProduct,
  productModalShow,
  setProductModalShow,
  handleClickApprove,
  handleClickDecline,
  styles,
  modalApproveBtn,
  modalDeclineBtn,
  modalCloseBtn,
  modalLoading,
}) {
  return (
    <React.Fragment>
      <Modal
        show={productModalShow}
        onHide={() => setProductModalShow(false)}
        dialogClassName="modal-90w"
        keyboard={false}
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            Product Update Details for{' '}
            {selectedProduct?.approved_at === null &&
            selectedProduct?.declined_at === null
              ? 'Approval'
              : selectedProduct?.approved_at !== null &&
                selectedProduct?.declined_at === null
              ? 'Approved'
              : selectedProduct?.approved_at === null &&
                selectedProduct?.declined_at !== null
              ? 'Declined'
              : null}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3 px-2">
            <strong>Product:</strong>{' '}
            {selectedProduct?.product_code
              ? `${selectedProduct.product_code} - `
              : ''}
            {selectedProduct?.product_name}
          </div>
          <div className="row">
            <div className="col-md-6">
              <br />
              <section style={styles.fieldset}>
                <legend style={styles.legend}>Product Payment Terms</legend>
                <br />
                <div className="form-group row" style={styles.formGroup}>
                  <div
                    className="col-sm-6 row pr-0"
                    style={{ marginTop: '6px' }}
                  >
                    <div className="col-sm-12 row">
                      <ProductInput
                        name="percent_down_payment"
                        value={selectedProduct?.percent_down_payment}
                        changesField={selectedProduct?.changes?.text}
                      />
                    </div>
                  </div>

                  <ProductLabel text="% Down Payment" />
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <div
                    className="col-sm-6 row pr-0"
                    style={{ marginTop: '6px' }}
                  >
                    <div className="col-sm-12 row">
                      <ProductInput
                        name="percent_intransit"
                        value={selectedProduct?.percent_intransit}
                        changesField={selectedProduct?.changes?.text}
                      />
                    </div>
                  </div>
                  <ProductLabel text="% In Transit" />
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <div
                    className="col-sm-6 row pr-0"
                    style={{ marginTop: '6px' }}
                  >
                    <div className="col-sm-12 row">
                      <ProductInput
                        name="percent_upon_delivery"
                        value={selectedProduct?.percent_upon_delivery}
                        changesField={selectedProduct?.changes?.text}
                      />
                    </div>
                  </div>
                  <ProductLabel text="% Upon Delivery" />
                </div>
                <br />
                <div className="col-md-12">
                  {selectedProduct?.payment_terms?.map((item, index) => (
                    <div className="row" key={index}>
                      <div className="col-md-4">
                        <input
                          name={`payments[${index}][percent_amount]`}
                          value={item?.percent_amount}
                          changesField={selectedProduct?.changes?.text}
                          className={`form-control form-control-sm text-dark ${
                            selectedProduct?.changes?.text?.find(
                              (rows) => rows?.field_name === 'percent_amount',
                            )
                              ? 'red-input'
                              : ''
                          }`}
                        />
                      </div>

                      <div className="col-md-4">
                        <input
                          name={`payments[${index}][days_remaining]`}
                          value={item?.days_remaining}
                          changesField={selectedProduct?.changes?.text}
                          className={`form-control form-control-sm text-dark ${
                            selectedProduct?.changes?.text?.find(
                              (rows) => rows?.field_name === 'days_remaining',
                            )
                              ? 'red-input'
                              : ''
                          }`}
                        />
                      </div>

                      <div className="col-md-3">
                        <label
                          className="col-sm-12 fs-6"
                          style={{ marginTop: '6px' }}
                        >
                          After Delivery
                        </label>
                      </div>
                    </div>
                  ))}
                </div>
                <br />
              </section>
            </div>
            <div className="col-md-6" style={styles.divPadding}>
              <section style={styles.fieldset}>
                <legend style={styles.legend}>Price & Cost</legend>
                <br />

                <div className="form-group row" style={styles.formGroup}>
                  <p className="text-danger">
                    Note: Fill out{' '}
                    <span className="font-weight-bold">
                      Cost Per Box and Selling Price Per Box
                    </span>{' '}
                    First and{' '}
                    <span className="font-weight-bold">Quantity Per Pack</span>{' '}
                    to compute Per Unit and VAT Ex.
                  </p>
                </div>
                <br />
                <div className="form-group row" style={styles.formGroup}>
                  <label
                    for="vat_exemption"
                    className="col-sm-4 col-form-label col-form-label-sm"
                  ></label>
                  <div className="col-sm-8" style={{ marginLeft: '-15px' }}>
                    <ProductCheckbox
                      name="vat_exemption"
                      value={selectedProduct?.vat_exemption}
                      label={`${' '}Vat Exemption`}
                      changesField={selectedProduct?.changes?.vat_exemption}
                    />
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <label
                    for="cost"
                    className="col-sm-4 col-form-label col-form-label-sm"
                  >
                    Cost Per Box <span className="float-right">&#8369;</span>
                  </label>
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-11 row">
                      <ProductInput
                        name="cost"
                        value={selectedProduct?.cost.toFixed(2)}
                        changesField={selectedProduct?.changes?.text}
                      />
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <label
                    for="cost_vat"
                    className="col-sm-4 col-form-label col-form-label-sm"
                  >
                    Cost Per Box (Vat Ex){' '}
                    <span className="float-right">&#8369;</span>
                  </label>
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-11 row">
                      <ProductInput
                        name="cost_vat"
                        value={selectedProduct?.cost_vat.toFixed(2)}
                        changesField={selectedProduct?.changes?.text}
                      />
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <label
                    for="cost_unit"
                    className="col-sm-4 col-form-label col-form-label-sm"
                  >
                    Cost Per Unit
                    <span className="float-right">&#8369;</span>
                  </label>
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-11 row">
                      <ProductInput
                        name="cost_unit"
                        value={selectedProduct?.cost_unit.toFixed(2)}
                        changesField={selectedProduct?.changes?.text}
                      />
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <label
                    for="cost_vat_unit"
                    className="col-sm-4 col-form-label col-form-label-sm"
                  >
                    Cost Per Unit (Vat Ex){' '}
                    <span className="float-right">&#8369;</span>
                  </label>
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-11 row">
                      <ProductInput
                        name="cost_vat_unit"
                        value={selectedProduct?.cost_unit_vat.toFixed(2)}
                        changesField={selectedProduct?.changes?.text}
                      />
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <label
                    for="selling_price"
                    className="col-sm-4 col-form-label col-form-label-sm"
                  >
                    Selling Price Per Box{' '}
                    <span className="float-right">&#8369;</span>
                  </label>
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-11 row">
                      <ProductInput
                        name="selling_price"
                        value={selectedProduct?.selling_price.toFixed(2)}
                        changesField={selectedProduct?.changes?.text}
                      />
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <label
                    for="selling_price_vat"
                    className="col-sm-4 col-form-label col-form-label-sm"
                  >
                    Selling Price Per Box(Vat Ex){' '}
                    <span className="float-right">&#8369;</span>
                  </label>
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-11 row">
                      <ProductInput
                        name="selling_price_vat"
                        value={selectedProduct?.selling_price_vat.toFixed(2)}
                        changesField={selectedProduct?.changes?.text}
                      />
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <label
                    for="selling_price_unit"
                    className="col-sm-4 col-form-label col-form-label-sm"
                  >
                    Selling Price Per Unit{' '}
                    <span className="float-right">&#8369;</span>
                  </label>
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-11 row">
                      <ProductInput
                        name="selling_price_unit"
                        value={selectedProduct?.selling_price_unit.toFixed(2)}
                        changesField={selectedProduct?.changes?.text}
                      />
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <label
                    for="selling_price_unit_vat"
                    className="col-sm-4 col-form-label col-form-label-sm"
                  >
                    Selling Price Per Unit (Vat Ex){' '}
                    <span className="float-right">&#8369;</span>
                  </label>
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-11 row">
                      <ProductInput
                        name="selling_price_unit_vat"
                        value={selectedProduct?.selling_price_unit_vat.toFixed(
                          2,
                        )}
                        changesField={selectedProduct?.changes?.text}
                      />
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
          <div className="row pt-5">
            <div className="col-md-8">
              <ChangesTable data={selectedProduct} />
            </div>
            <div className="col-md-4 d-flex gap-2 justify-content-center align-items-end">
              {selectedProduct?.approved_at === null &&
                selectedProduct?.declined_at === null && (
                  <React.Fragment>
                    <button
                      className="btn btn-success btn-sm changes-tbl-btn"
                      onClick={() => handleClickApprove(selectedProduct)}
                      disabled={modalApproveBtn}
                    >
                      Approve
                    </button>
                    <button
                      className="btn btn-danger btn-sm changes-tbl-btn"
                      onClick={() => handleClickDecline(selectedProduct)}
                      disabled={modalDeclineBtn}
                    >
                      Declined
                    </button>
                    <button
                      className="btn btn-outline-secondary btn-sm changes-tbl-btn"
                      onClick={() => setProductModalShow(false)}
                      disabled={modalCloseBtn}
                    >
                      Close
                    </button>
                  </React.Fragment>
                )}
            </div>
          </div>
          {/* 
          {modalLoading && (
            <Backdrop
              sx={(theme) => ({
                color: '#fff',
                zIndex: theme.zIndex.drawer + 1,
              })}
              open={modalLoading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          )} */}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
});

export default ProductModal;
